'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["currencyStyle", "validCurrencies", "currenciesFilter"];
import { currencyStyles } from 'I18n/internal/utils/CurrencyLabelFormatters';
import { Select } from 'foundations-components/transitional/components/Select';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { getCurrencyOptions } from '../internal/utils/CurrencyFormatting';
import { jsx as _jsx } from "react/jsx-runtime";
const CurrencySelect = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      currencyStyle = currencyStyles.short,
      validCurrencies,
      currenciesFilter
    } = _ref,
    passThroughProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Select, Object.assign({}, passThroughProps, {
    ref: ref,
    options: getCurrencyOptions({
      currencyStyle,
      currenciesFilter,
      validCurrencies
    })
  }));
});
CurrencySelect.propTypes = {
  className: PropTypes.string,
  currencyStyle: PropTypes.oneOf(Object.keys(currencyStyles)).isRequired,
  validCurrencies: PropTypes.array,
  currenciesFilter: PropTypes.func
};
export default CurrencySelect;